export default {
    Title: 'Tham số báo cáo',
    Year: 'Năm',
    All: 'Tất cả',
    Summary: 'Tổng hợp',
    Option: 'Tùy chọn',
    Source: 'Nguồn',
    Chapter: 'Chương',
    BudgetSubKindItem: 'Khoản',
    BudgetItem: 'Mục',
    BudgetSubItem: 'Tiểu mục',
    TemplateReport: 'Mẫu báo cáo',
    OptionsGetData: 'Tùy chọn lấy số liệu',
    SetupFormula: 'Thiết lập công thức',
    DisplayOption: 'Tùy chọn hiển thị',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    SelectAll: '<<Tất cả>>',
  };
  